import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_BOOKS_SET_DATA,
  SEARCH_SEARCH_BOOKS_RESET_DATA,
} from 'rebook/apps/search/constants';


export function fetchInitialData(location = {}) {
  return async(dispatch, getState) => {
    const { ssr, searchBooks: currentState } = getState();
    const limit = 12;
    const pageNumber = parseInt(get(ssr, 'query.page', 1));

    let newState = {
      pageNumber,
    };
    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
        lastPageNumber: Math.ceil(location.state.booksCount / limit),
      };
    }

    dispatch(setData(newState));
    if (!newState.bookList || currentState.pageNumber !== pageNumber) {
      await dispatch(fetchBook(pageNumber));
    }
  };
}

export function fetchBook(pageNumber = 1) {
  return async(dispatch, getState) => {
    const { ssr, searchBooks: currentState } = getState();
    const limit = 12;

    let query;

    if (ssr.query && ssr.query.q) {
      query = ssr.query.q;
    }
    else {
      query = currentState.query;
    }

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    dispatch(setData({ isLoading: true }));

    let queryParams = {
      q: query,
      limit,
      offset: (pageNumber - 1) * limit,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/search/books/?${qs}`;

    return await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        const lastPageNumber = Math.ceil(data.meta.total_count / limit);
        dispatch(setData({
          bookList: data.objects,
          booksCount: data.meta.total_count,
          query,
          pageNumber,
          lastPageNumber,
          isLoading: false,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load book list book due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load book list book detail due to server error');
        }
      });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { ssr, searchBooks: currentState } = getState();
    let bookName;

    if (ssr.query && ssr.query.q) {
      bookName = ssr.query.q;
    }
    else {
      bookName = currentState.query;
    }

    const title = `Все книги по запросу «${bookName}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { bookList } = payload;
    dispatch({
      type: SEARCH_SEARCH_BOOKS_SET_DATA,
      payload,
    });
    if (bookList) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_BOOKS_RESET_DATA,
    });
  };
}
